export const STS_AUTHORITY = process.env.REACT_APP_STS_AUTHORITY;
export const CLIENT_ID = process.env.REACT_APP_CLIENT_ID;
export const CLIENT_ROOT = process.env.REACT_APP_CLIENT_ROOT;
export const CLIENT_SCOPE = process.env.REACT_APP_CLIENT_SCOPE;
